import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { App } from './App';
import ErrorBoundaryComponent from './components/Errors/ErrorBoundary/ErrorBoundaryComponent';
import { APP_ROOT_ID } from './stores/constants';
import TestPDP from './pages/TestPDP';
// import TestBasket from './pages/TestBasket';

const rootElement = document.getElementById(APP_ROOT_ID);

const isTestingEnvironment = process.env.REACT_APP_ENV === 'dev';
// const isBasketTestingEnvironment = process.env.REACT_APP_PAGE_TYPE === 'basket';

if (rootElement?.hasChildNodes()) {
    hydrateRoot(
        rootElement,
        <ErrorBoundaryComponent>
            <App />
        </ErrorBoundaryComponent>,
    );
} else {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const root = createRoot(rootElement!);
    root.render(
        <ErrorBoundaryComponent>
            {/*<App />*/}
            {/* {isTestingEnvironment ? isBasketTestingEnvironment ? <TestBasket /> : <TestPDP /> : <App />} */}
            {isTestingEnvironment ? <TestPDP /> : <App />}
        </ErrorBoundaryComponent>,
    );
}
